import { Article, ArticleVariant, PaginatedResponse } from '@repo/types';
import { Pagination } from '../../../siteStructure/components/Pagination';
import { ArticleCard } from '../ArticleCard';
import classNames from 'classnames';
import { ArticleListProps, ArticleListVariant } from './contracts';

export type ArticleListUIProps = ArticleListProps & {
  paginatedArticles: PaginatedResponse<Article>;
};

export default function ArticleListUI({
  title,
  paginatedArticles,
  withPagination,
  variant,
  listVariant,
  showDate,
  showAuthor,
  showImage,
  showSummary,
  showTag,
  columns = 1,
  prioritize = false,
}: ArticleListUIProps) {
  if (!paginatedArticles?.items || paginatedArticles.items.length === 0) {
    return null;
  }

  const className = classNames('article-card-list-container', {
    'article-card-list-container--with-pagination': withPagination,
    'article-card-list-container--default': variant === ArticleVariant.Default,
    'article-card-list-container--text-side-by-side': variant === ArticleVariant.TextSideBySide,
    'article-card-list-container--two-column-grid': listVariant === ArticleListVariant.TwoColumnGrid,
  });

  return (
    <div className={className} id="article-list">
      {title && <h3 className="article-card-list-container__title">{title}</h3>}
      <ul className="article-card-list-container__list" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {paginatedArticles.items.map((article) => {
          return (
            <li className="article-card-list-container__list-item" key={article.id}>
              <ArticleCard
                variant={variant}
                article={article}
                showDate={showDate}
                showAuthor={showAuthor}
                showImage={showImage}
                showSummary={showSummary}
                showTag={showTag}
                prioritize={prioritize}
              />
            </li>
          );
        })}
      </ul>
      {withPagination && (
        <Pagination
          forcePage={paginatedArticles.pagination.currentPage - 1}
          pageCount={paginatedArticles.pagination.totalPages}
        />
      )}
    </div>
  );
}
